module.exports = __webpack_public_path__ + "static/media/10mei.3d3d40b7.jpeg";